<h1 matDialogTitle>{{title}}</h1>
<div mat-dialog-content style="padding-bottom:10px;" [innerHTML]="text"></div>
<img *ngIf="imageName" style="padding-bottom:10px;max-width:65%;" src="{{imageSource}}" class="img-fluid" alt="Help Image">
<div *ngIf="text2" mat-dialog-content style="padding-bottom:10px;" [innerHTML]="text2"></div>
<img *ngIf="imageName2" style="max-width:65%;" src="{{imageSource2}}" class="img-fluid" alt="Help Image">
<div mat-dialog-actions class="pt-24">
    <button mat-button (click)="dialogRef.close(false)">OK</button>
</div>
